export default "__VITE_ASSET__YxOL$jrg__"